/**
 * The `data-testid` values `PageImage` draws on a canvas image item: the
 * "Edited with AI" tag an item carries while it shows a background removal
 * or an enhancement. `PageImage` draws them from here and its tests import
 * them from here.
 */
export const PAGE_IMAGE_TEST_IDS = {
  AI_TAG: 'editor-image-ai-tag',
} as const
